import {TagTemplate} from '../../../components/common/dropdowns/tags/tagEditorBody';
import {serializeTagBulkActionTemplate, TagBulkActionTemplate} from '../../../models/api/tagBulkActionModel';
import {TagModel} from '../../../models/api/tagModel';
import {patchAsync} from '../../../services/http/http';
import {ThunkAsyncAction} from '../../appThunk';
import {getCompany} from '../company/companySelectors';
import {getUserId} from '../teammates/teammatesSelectors';
import {createTagAction} from './saveTagActions';

export function tagsBulkAction(template: TagBulkActionTemplate): ThunkAsyncAction {
  return async (_dispatch, getState) => {
    const company = getCompany(getState());
    const userId = getUserId(getState());

    const url = `${company.url}/namespaces/${template.namespace}/tags_bulk`;

    try {
      const body = serializeTagBulkActionTemplate(template, userId);

      await patchAsync(url, body);
    } catch (e) {
      console.error(e);
    }
  };
}

export function nestTagsInsideNewParentTagAction(
  parentTemplate: TagTemplate,
  bulkTemplateGetter: (newTag: TagModel) => TagBulkActionTemplate,
): ThunkAsyncAction<TagModel | undefined> {
  return async (dispatch, getState) => {
    const newTag = await dispatch(createTagAction(parentTemplate));

    if (!newTag) {
      return undefined;
    }

    await dispatch(tagsBulkAction(bulkTemplateGetter(newTag)));

    return newTag;
  };
}
